export enum UserActionsEnum {
  LIKE = "like",
  DISLIKE = "dislike",
  SHARE = "share",
  COMMENT = "comment",
  PREDICTION_MADE = "prediction_made",
}
